'use strict';

import React from 'react';
import classNames from 'classnames';

class Group extends React.Component {
    render() {
        var classes = classNames(
            'group',
            'clear',
            this.props.className, {
                'pad-bottom': this.props.padBottom,
            }
        );

        return (
            <div className={classes}>
                {this.props.label ? <div className="group-label">{this.props.label}</div> : null}
                {this.props.children}
            </div>
        );
    }
}

export default Group;